/**
 * Project : workspace
 * File    : WebHomeBannerSection.kt
 * Created : AUTO-GENERATED by scripts/add_kdoc.py
 */

package presentation.screens.business.homepage.component

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxHeight
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.layout.wrapContentHeight
import androidx.compose.foundation.layout.wrapContentWidth
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import androidx.compose.ui.zIndex
import com.parmartechnologies.communication.core.viewModel.AuthViewModel
import common.asset.ImageAsset
import component.button.DefaultButton
import component.dimension.ScreenDimension
import component.image.AsyncImageView
import component.image.FriendlyIcon
import org.jetbrains.compose.ui.tooling.preview.Preview
import theme.ThemeColor
@Preview
@Composable
/**
 * Executes the web home banner section operation.
 *
 * @receiver TODO
 * @return Unit – no return value.
 */
fun WebHomeBannerSection() {
    Box(
        modifier = Modifier.height(ScreenDimension().height(0.6f))
            .width(ScreenDimension().width(1.0f))
            .background(
//                brush = Brush.horizontalGradient(
//                    ThemeColor.shared().homeBackground
//                ),
                color = ThemeColor.shared().cardBackground
            ),
    ) {
        Box(modifier = Modifier.fillMaxWidth().fillMaxHeight().zIndex(-1f)) {
            AsyncImageView("https://firebasestorage.googleapis.com/v0/b/friendly-221119.appspot.com/o/website%2Fbanner%2Fgradient_background.png?alt=media&token=646b06f7-0473-477e-88a4-829e4a709fc8")
        }
        Box(modifier = Modifier.fillMaxWidth().fillMaxHeight().zIndex(1f)) {
            Row(modifier = Modifier.fillMaxWidth().fillMaxHeight()) {
                Column(
                    modifier = Modifier
                        .fillMaxHeight()
                        .weight(1f)
                        .fillMaxWidth()
//                        .padding(start = 100.dp)
                    ,
                    horizontalAlignment = Alignment.Start,
                    verticalArrangement = Arrangement.Center

                ) {
                    Column(
                        modifier = Modifier.fillMaxSize().weight(0.5f),
                        horizontalAlignment = Alignment.Start,
                        verticalArrangement = Arrangement.Center
                    ) {
                        Column(modifier = Modifier.wrapContentHeight().wrapContentWidth()) {
                            Text(
                                "Your",
                                fontSize = 45.sp,
//                                lineHeight = 50.sp,
                                color = Color.Black,
                                fontWeight = FontWeight.Bold,
                                modifier = Modifier.wrapContentWidth().wrapContentHeight()
                            )
                            Text(
                                " One-Stop          ",
                                fontSize = 35.sp,
                                color = ThemeColor.shared().lightGreenText,
                                fontWeight = FontWeight.ExtraBold,
                                modifier = Modifier.wrapContentWidth().wrapContentHeight()
                            )
                        }
                        Text(
                            "Solution for Business &",
                            fontSize = 35.sp,
//                            lineHeight = 50.sp,
                            color = Color.Black,
                            fontWeight = FontWeight.Bold,
                            modifier = Modifier.wrapContentWidth().wrapContentHeight()
                        )
                        Text(
                            "Consumer Needs       ",
                            fontSize = 35.sp,
//                            lineHeight = 50.sp,
                            color = Color.Black,
                            fontWeight = FontWeight.Bold,
                            modifier = Modifier.wrapContentWidth().wrapContentHeight()
                        )

                        Text(
                            "Discover the ultimate solution for seamless business",
                            color = Color.Gray,
                            fontSize = 20.sp,
//                            lineHeight = 30.sp,
                            modifier = Modifier.padding(top = 8.dp).wrapContentHeight()
                        )
                        Text(
                            "management and customer engagement.                  ",
                            color = Color.Gray,
                            fontSize = 20.sp,
//                            lineHeight = 30.sp,
                            modifier = Modifier.padding(top = 0.dp).wrapContentHeight()
                        )
                        SatisfiedClientsRow()
                        Box(
                            modifier = Modifier.height(70.dp).width(200.dp)
                                .padding(top = 20.dp)
                        ) {
                            DefaultButton(
                                "Get Started",
                                onClick = {
                                    AuthViewModel().showAuthContainer()
                                },
                            )
                        }
                    }
                }
                Column(
                    modifier = Modifier
                        .weight(0.1f)
                        .fillMaxHeight()
                        .fillMaxWidth(),
                    verticalArrangement = Arrangement.Center,
                    horizontalAlignment = Alignment.CenterHorizontally
                ) {
                    FriendlyIcon(
                        size = ScreenDimension().heightHalf().toInt(),
                        width = ScreenDimension().widthHalf().toInt(),
                        name = ImageAsset.screenshot1
                    )

                }
            }
        }
    }
}